

// Translate Participant Role to String Display
export const roleTranslations = (role) => {
  const translations = {
    RegistrarPayingAgent: 'Registrar & Paying Agent',
    SellingAgent: 'Selling Agent',
    UnderwriterArranger: 'Underwriter/Arranger',
    MarketMaker: 'Market Maker',
    Trustee: 'Trustee',
    BrokerSpecialist: 'Broker Specialist'
  }
  if( role.includes('Custom') ) {
    return role.split('-')[1];
  }
  return translations[role]
}


